import { graphql } from 'gatsby'
import React from 'react'
import SEO from '../components/shared/Seo'
import Seo from '../components/seo'
import Hero from '../components/Hero/Hero'
import SectionFeature from '../components/SectionFeature/SectionFeature'
import TextBlock from '../components/TextBlock/TextBlock'
import { useUrl } from '../hooks/layout/useUrl'
const BrewConnoisseurs = ({
    location,
    pageContext,
    data: {
        contentfulEkaterraBrewConnoisseurs: {
            title,
            slug,
            node_locale,
            seoTitle,
            seoDescription,
            sections
        },
        allContentfulEkaterraBrewConnoisseurs: {
            nodes
        }
    }
}) => {
    const lang = useUrl()
    return (
        <>
            <Seo
                slug={slug}
                title={seoTitle}
                description={seoDescription && seoDescription.seoDescription}
                node_locale={node_locale}
                lang={lang}
                hreflangs={nodes}
            />
            {
                sections.map((section: any, id: number) => {
                    switch (section.__typename) {
                        case 'ContentfulSectionComponentHero':
                            return <Hero data={section} key={id} />
                        case 'ContentfulComponentFeature':
                            return (
                                <div className='TextWithDescription_BrewConnoisseurs'>
                                    <SectionFeature data={section} imageTop={true} noMargin={true} key={id} />
                                </div>
                            )
                        case 'ContentfulComponentTestWithDescription':
                            return (
                                <div className='description-text container container-md' key={id}>
                                    <h2 className='text-center'>{section.heading}</h2>
                                    <div className='TextWithDescription_BrewConnoisseurs'>
                                        <TextBlock data={section.description} />
                                    </div>
                                </div>

                            )
                        default:
                            return null
                    }
                })
            }
        </>
    )
}
export const BrewConnoisseursQuery = graphql`
    query EkaterraBrewConnoisseurs($id:String!, $contentful_id: String! ){
        contentfulEkaterraBrewConnoisseurs(id:{eq:$id}) {
            name
            node_locale
            slug
            seoTitle
            seoDescription{
                seoDescription
              }
            sections {
                __typename
                ... on ContentfulComponentFeature {
                  id
                  title
                  appearance
                  headingLevel
                  alignment
                  description {
                    raw
                  }
                  images {
                    gatsbyImageData
                    title
                }
                }
                ... on ContentfulSectionComponentHero {
                    id
                    title
                    description {
                      raw
                    }
                  }
                ... on ContentfulComponentTestWithDescription {
                  id
                  heading
                  description {
                    raw
                  }
                }
            }
        }
        allContentfulEkaterraBrewConnoisseurs(filter: {contentful_id: {eq: $contentful_id}, id: {nin: [$id,"f928b0d3-434e-5ce1-b52e-bf1d2339f952"]}}){
            nodes {
                slug
                node_locale
            }
        }
    }
`

export default BrewConnoisseurs